import React, { Component } from 'react';
import { Redirect } from 'react-router';
import Cart from './Cart';
import SideMenu from '../SideMenu/SideMenu';
import s from './CartPage.scss';

class CartPage extends Component {
	componentDidMount() {
		this.props.updatePreviousPage(this.props.match.url);
	}

	componentDidUpdate() {
		this.props.updatePreviousPage(this.props.match.url);
	}

	render() {
		const { shop, productList, setup, adjustItem, toggleSideMenu, navigation } = this.props;
		if (setup.siteClosed === true) return <Redirect to="/" />;
		if (setup.static === undefined) return null;
		const contentClasses = [s.content];
		if (navigation.sideMenuOpen) contentClasses.push(s.content__mobileMenuOpen);

		return (
			<main className={s.cartPage} role="main">
				<SideMenu navigation={navigation} toggleSideMenu={toggleSideMenu} staticTexts={setup.static} />
				<div className={contentClasses.join(' ')}>
					<h1 className={s.cartPage_title}>{setup.static.orderSummary}</h1>
					{
						shop.checkout.ID ? <Cart shop={shop} productList={productList} staticTexts={setup.static} adjustItem={adjustItem} /> : null
					}
				</div>
			</main>
		);
	}
}

export default CartPage;



// WEBPACK FOOTER //
// ./components/Cart/CartPage.jsx